<template>
    <div class="container pt-2">
        <PageTitle main="Alterar Senha" sub="Alteração de senha" />
        <b-form>
            <input id="pass-id" type="hidden" v-model="pass.id" />
            <div class="row">
                <div class="col-md-4">
                    <b-form-group label="Senha Atual:" label-for="pass-old">
                        <b-form-input id="pass-old" type="password"
                            v-model="pass.old"
                            placeholder="Digite a senha atual."
                            :class="{ 'inputError': $v.pass.old.$error }"
                            class="textInput"
                            @keydown.tab="$v.pass.old.$touch"/>
                        <span class="error" v-if="!$v.pass.old.required && $v.pass.old.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.pass.old.minLength && $v.pass.old.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Senha Nova:" label-for="pass-new">
                        <b-form-input id="pass-new" type="password"
                            v-model="pass.new"
                            placeholder="Digite a nova senha."
                            :class="{ 'inputError': $v.pass.new.$error }"
                            class="textInput"
                            @keydown.tab="$v.pass.new.$touch"/>
                        <span class="error" v-if="!$v.pass.new.required && $v.pass.new.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.pass.new.minLength && $v.pass.new.$error">Precisa ter no mínimo 3 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-4">
                    <b-form-group label="Confirmar Senha Nova:" label-for="pass-confirm">
                        <b-form-input id="pass-confirm" type="password"
                            v-model="pass.confirm"
                            placeholder="Confirme a nova senha."
                            :class="{ 'inputError': $v.pass.confirm.$error }"
                            class="textInput"
                            @keydown.tab="$v.pass.confirm.$touch"/>
                        <span class="error" v-if="!$v.pass.confirm.sameAsPassword && $v.pass.confirm.$error">Senha precisa ser igual a nova senha!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="botaoInput" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset">Cancelar</b-button>
        </b-form>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'meClientes',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            pass: {},
            level: '',
            quemRecebeu: '',
            nome: '',
            email: ''
        }
    },
    validations: {
        pass: {
            old: {
                required,
                minLength: minLength(4)
            },
            new: {
                required,
                minLength: minLength(4)
            },
            confirm: {
                sameAsPassword: sameAs('new')
            }
        }
    },
    methods: {
        reset() {
            this.pass = {}
            this.$v.pass.$reset()
        },
        save() {
            this.$v.pass.$touch()
            if(!this.$v.pass.$error){
                this.pass.level = this.level
                this.pass.id = this.quemRecebeu
                axios['post'](`${baseApiUrl}/backend/alteraSenha.php`, this.pass)
                    .then(() => {
                        // if(this.level==='cliente'){
                        //     const tipo = `?tipo=senhaCliente`
                        //     const destinoEmail = `&destinoEmail=${this.email}`
                        //     const destinoNome = `&destinoNome=${this.nome}`
                        //     axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({})
                        // }else{
                        //     const tipo = `?tipo=senhaFuncionario`
                        //     const destinoEmail = `&destinoEmail=${this.email}`
                        //     const destinoNome = `&destinoNome=${this.nome}`
                        //     axios.get(`${baseApiUrl}/backend/mailFuncionario.php${tipo}${destinoEmail}${destinoNome}`).then({})
                        // }
                        

                        this.$toasted.global.defaultSuccess({ message : 'Senha alterada com sucesso!' })
                        this.reset()
                        this.logout()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        logout () {
            localStorage.removeItem('__SYSTEM_USER')
            this.$router.push({ name: 'login' })
            this.$store.commit('toggleVisible', false)
            this.$toasted.global.defaultSuccess({ message : 'Logout Realizado com sucesso!' })
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
    }
}
</script>

<style>

</style>